import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IOsaExecucaoProgramaTrabalhoQuestaoModel } from "../../../../../models/osa-execucao-programa-trabalho.model";
import { OsaExecucaoProgramaTrabalhoService } from "../../../../../services/osa-execucao-programa-trabalho.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar',
  templateUrl: './osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-programa-trabalho-questao-incid-selecionar.component.scss'],
})
export class OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidSelecionarComponent implements OnInit {

  public osaExecucaoProgramaTrabalhoId: number = 0;
  public dataSource = new MatTableDataSource<IOsaExecucaoProgramaTrabalhoQuestaoModel>([]);
  public listaCompleta: IOsaExecucaoProgramaTrabalhoQuestaoModel[] = [];
  public selecionada: IOsaExecucaoProgramaTrabalhoQuestaoModel | null = null;
  public filtro: string = '';
  public carregando: boolean = true;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public osaExecucaoProgramaTrabalhoService: OsaExecucaoProgramaTrabalhoService,
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgramaTrabalhoQuestaoIncidSelecionarComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.osaExecucaoProgramaTrabalhoId = data?.osaExecucaoProgramaTrabalhoId;
  }

  ngOnInit(): void {
    this.carregarQuestoesDisponiveis();
  }

  public carregarQuestoesDisponiveis() {
    this.carregando = true;
    this.osaExecucaoProgramaTrabalhoService
      .obterQuestoesIncidentaisDoPlanejamento(this.osaExecucaoProgramaTrabalhoId)
      .then((res) => {
        if (res.sucesso) {
          this.listaCompleta = res.dados || [];
          this.dataSource.data = this.listaCompleta;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem?.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .finally(() => this.carregando = false);
  }

  public aplicarFiltro() {
    const termo = (this.filtro || '').trim().toLowerCase();
    if (!termo) {
      this.dataSource.data = this.listaCompleta;
      return;
    }
    this.dataSource.data = this.listaCompleta.filter(q =>
      q.identificador?.toLowerCase().includes(termo) ||
      q.descricao?.toLowerCase().includes(termo)
    );
  }

  public selecionarLinha(item: IOsaExecucaoProgramaTrabalhoQuestaoModel) {
    this.selecionada = this.selecionada?.id === item.id ? null : item;
  }

  public confirmarSelecao() {
    if (!this.selecionada) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Selecione uma questão incidental para reaproveitar!",
      });
      return;
    }
    this.dialogRef.close({ modo: 'existente', questao: this.selecionada });
  }

  public novaQuestao() {
    this.dialogRef.close({ modo: 'nova' });
  }

  public cancelar() {
    this.dialogRef.close();
  }
}